import React from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import { useFormikContext } from 'formik';
import Text from 'components/Text';
import { formatPrice } from 'utils/format';
import Model from '../../../../../model';
import './index.sass';

const { block, el } = bem('course-summary');
const Summary = ({ price }) => {

    const { values: { saleSum } } = useFormikContext();
    const { showBalanceInSummary, isKZ } = Model.kz;
    const total = isKZ ? +price : +price - +saleSum;
    const balanceValue = +saleSum === 0 ? formatPrice(saleSum) : `-${formatPrice(saleSum)}`;

    return (
        <div className={ block() }>
            { showBalanceInSummary && <>
                <div className={ el('details-costs', 'items') }>
                    <Text className={ el('details-label') }>
                        Стоимость заказа
                    </Text>
                    <Text className={ el('details-value') }>
                        { formatPrice(price) }
                    </Text>
                </div>
                <div className={ el('details-costs', { 'balance': true }) }>
                    <Text className={ el('details-label') }>
                        Оплата баллами
                    </Text>
                    <Text className={ el('details-value') }>
                        { balanceValue }
                    </Text>
                </div>
            </> }
            <div className={ el('details-costs', 'total') }>
                <Text className={ el('details-label') }>
                    Итого к оплате
                </Text>
                <Text className={ el('details-value') }>
                    { formatPrice(total) }
                </Text>
            </div>
        </div>
    )
};

export default observer(Summary);
